import { render, staticRenderFns } from "./PendingDelete.vue?vue&type=template&id=4904df08&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4904df08')) {
      api.createRecord('4904df08', component.options)
    } else {
      api.reload('4904df08', component.options)
    }
    module.hot.accept("./PendingDelete.vue?vue&type=template&id=4904df08&", function () {
      api.rerender('4904df08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/serviceStatus/PendingDelete.vue"
export default component.exports